// // ################ 3 #######################
// /* eslint-disable */
// import React from "react";
// import DualCircleProgress from "./DualCircleProgress";
// import styles from './tiles.module.css';

// const TileCardDual = ({ title, timeliness, accuracy, color1, color2 }) => {
//   return (
//     <div className={styles.tile_card}>
//       <p className={styles.tile_title}>{title}</p>
//       <div className={styles.text_section}>
//         <div style={{ alignItems: "center", marginBottom: "8px" }}>
//           <span className={styles.dot}></span> <span style={{ marginRight: "4px", fontSize:"12px", fontWeight:"600" }}>Timeliness:{" "}</span>
//           <span style={{ color: color1, marginRight: "4px", fontSize:"12px", fontWeight:"600" }}>{timeliness}%</span>
//         </div>
//         <div style={{ alignItems: "center", marginBottom: "8px" }}>
//           <span className={styles.dot}></span><span style={{ marginRight: "4px", fontSize:"12px", fontWeight:"600" }}>Accuracy:{" "}</span>
//           <span style={{ color: color2, marginRight: "4px", fontSize:"12px", fontWeight:"600" }}>{accuracy}%</span>
//         </div>
//       </div>
//       <div className={styles.circle_section}>
//         <DualCircleProgress
//           timeliness={timeliness}
//           accuracy={accuracy}
//           color1={color1}
//           color2={color2}
//         />
//       </div>
//     </div>
//   );
// };

// export default TileCardDual;

// ################## Responsvide Code #################
/* eslint-disable */
// import React from "react";
// import DualCircleProgress from "./DualCircleProgress";
// import styles from './tiles.module.css';

// const TileCardDual = ({ title, timeliness, accuracy, color1, color2 }) => {
//   return (
//     <div className={styles.tile_card}>
//       <p className={styles.tile_title}>{title}</p>

//       <div className={styles.content_row}>
//         {/* --- Text Section --- */}
//         <div className={styles.text_section}>
//           <div className={styles.text_item}>
//             <span className={styles.dot}></span>
//             <span className={styles.label}>Timeliness:</span>
//             <span className={styles.value} style={{ color: color1 }}>
//               {timeliness}%
//             </span>
//           </div>

//           <div className={styles.text_item}>
//             <span className={styles.dot}></span>
//             <span className={styles.label}>Accuracy:</span>
//             <span className={styles.value} style={{ color: color2 }}>
//               {accuracy}%
//             </span>
//           </div>
//         </div>

//         {/* --- Circle Progress --- */}
//         <div className={styles.circle_section}>
//           <DualCircleProgress
//             timeliness={timeliness}
//             accuracy={accuracy}
//             color1={color1}
//             color2={color2}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TileCardDual;


// ############### 2 ################
/* eslint-disable */
import React from "react";
import DualCircleProgress from "./DualCircleProgress";
import styles from "./tiles.module.css";

const TileCardDual = ({ title, timeliness, accuracy, color1, color2 }) => {
  return (
    <div className={styles.tile_card}>
      <p className={styles.tile_title}>{title}</p>
      <div className={styles.content_row}>
        <div className={styles.text_section}>
          <div className={styles.text_item}>
            <span className={styles.dot}></span>
            <span className={styles.label}>Timeliness:</span>
            <span className={styles.value} style={{ color: color1 }}>
              {timeliness}%
            </span>
          </div>

          <div className={styles.text_item}>
            <span className={styles.dot}></span>
            <span className={styles.label}>Accuracy:</span>
            <span className={styles.value} style={{ color: color2 }}>
              {accuracy}%
            </span>
          </div>
        </div>
        <div className={styles.circle_section}>
          <DualCircleProgress
            timeliness={timeliness}
            accuracy={accuracy}
            color1={color1}
            color2={color2}
          />
        </div>
      </div>
    </div>
  );
};

export default TileCardDual;
